import domContentLoaded from "dom-content-loaded";

export default () => {
  domContentLoaded(() => {
    // const setTrigger = () => {
    //   const bnrTriggerSection = document.querySelector(".p-home-nice-wrapper");
    //   const trigger =
    //     window.scrollY +
    //     bnrTriggerSection.getBoundingClientRect().top +
    //     bnrTriggerSection.offsetHeight -
    //     window.innerHeight;
    //   return trigger;
    // };

    const bnr = document.querySelector(".js_popup_bnr");
    const bnrClose = document.querySelector(".js_popup_bnrClose");
    const btnClose = document.querySelector(".js_popup_close");
    const btnOpen = document.querySelector(".js_popup_open");
    // let trigger = setTrigger();

    const bnrShow = () => {
      bnr.classList.remove("is_hide");
      bnr.classList.add("is_show");
      bnrClose.classList.remove("is_show");
      bnrClose.classList.add("is_hide");
    };

    const bnrHide = () => {
      bnr.classList.remove("is_show");
      bnr.classList.add("is_hide");
      bnrClose.classList.remove("is_hide");
      bnrClose.classList.add("is_show");
    };

    // window.addEventListener("load", () => {
    //   trigger = setTrigger();
    // });

    // window.addEventListener("resize", () => {
    //   trigger = setTrigger();
    // });

    setTimeout(() => {
      bnr.classList.add("is_show");
    }, 2000);

    // window.addEventListener("scroll", () => {
    //   if (
    //     window.scrollY > trigger &&
    //     !bnr.classList.contains("is_show") &&
    //     !bnr.classList.contains("is_hide")
    //   ) {
    //     bnr.classList.add("is_show");
    //   }
    // });

    btnClose.addEventListener("click", () => {
      bnrHide();
    });

    btnOpen.addEventListener("click", () => {
      bnrShow();
    });
  });
};
